import * as React from "react";
import { BackgroundPicker } from "@/components/Backgrounds/BackgroundPicker";
import { Dialog } from "@/components/ui";
import { BackgroundAsset, BackgroundRatio, BackgroundRequest } from "@/services/bedrock/dtos/BackgroundAsset";
import { ContextType, DesignBackground } from "@/services/bedrock/dtos/DesignPackage";

interface BackgroundPickerDialogProps {
  open: boolean;
  onOpenChange(open: boolean): void;
  itemPosition: number;
  ratio: BackgroundRatio;
  contextType: ContextType;
  excludeAssetIds: number[];
  onSelect(asset: BackgroundAsset | DesignBackground): void;
  onUpload(file: File): void;
  onGenerate(): void;
  uploading: boolean;
  uploadProgress: number | null;
  pendingRequests: BackgroundRequest[];
}

/** The tray's "Choose from library": the shared picker over the coach's and SocialCoach's backgrounds. */
export const BackgroundPickerDialog: React.FC<BackgroundPickerDialogProps> = ({
  open,
  onOpenChange,
  itemPosition,
  ratio,
  contextType,
  excludeAssetIds,
  onSelect,
  onUpload,
  onGenerate,
  uploading,
  uploadProgress,
  pendingRequests,
}) => (
  <Dialog open={open} onOpenChange={next => onOpenChange(next)} size="2xl">
    <Dialog.Header>
      <Dialog.Title>Choose a background</Dialog.Title>
      <Dialog.Description>Slide {itemPosition}</Dialog.Description>
    </Dialog.Header>
    <Dialog.Content className="max-h-[70vh] overflow-y-auto">
      {open && (
        <BackgroundPicker
          mode="coach"
          ratio={ratio}
          contextType={contextType}
          excludeAssetIds={excludeAssetIds}
          canUpload
          canGenerate
          onSelect={onSelect}
          onUpload={onUpload}
          onGenerate={onGenerate}
          uploading={uploading}
          uploadProgress={uploadProgress}
          pendingRequests={pendingRequests}
        />
      )}
    </Dialog.Content>
  </Dialog>
);
